'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('riskModule')

.controller('RiskExportExcelController', ['$scope', '$modal', function ($scope, $modal) {

    $scope.exportCtxt  = {
      environment: environment
    };

    $scope.selectGovernanceProcesses = function () {

        // Modal
        var modalScope = $scope.$new(true);

        var selectModal = $modal({
            scope: modalScope,
            template: '/app/shared/grc/risk/selectGovernanceProcessesForExportExcel.tpl.html',
            placement: 'center'
        });

        modalScope.hideModal = function () {
            selectModal.$promise.then(selectModal.hide);
        }

        modalScope.okModal = function () {
            modalScope.hideModal();
        }

        // Add the selected person
        modalScope.whenExportExcel = function (currentProcess, previousProcess) {
            var urlToDownload = environment.apiUrl + '/Pilot/api/Risk/ExportToExcel/ForGovernanceProcess/Current/' +
                                currentProcess.GovernanceProcessID +
                                '/And/Previous/' +
                                previousProcess.GovernanceProcessID;

            var form = angular.element(document.querySelector('#toDownload'));
            form.context.action = urlToDownload;
            form.submit();

            modalScope.okModal();
        }
    }
}]);
